export default __webpack_public_path__ + "static/media/signTheLeaseIcon.0da09964.svg";